import { selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getWithdrawalMinsAndFees } from 'services/api/payments'

import { Fetch, fetchSuccess } from './actions'
import { FETCH } from './actionTypes'
import { PaymentMethodWithdrawFeesAnMinData } from './reducers'

type Item = { minorValue: string; symbol: string; value: number }
type WithdrawalMinsAndFeesServiceResponse = {
  feeType: string
  fees: Array<Item>
  minAmounts: Array<Item>
}

const mapServiceResponse = (response: WithdrawalMinsAndFeesServiceResponse, getMinorUnits) => {
  const result: PaymentMethodWithdrawFeesAnMinData = {}
  for (let i = 0; i < response.fees.length; i += 1) {
    const fee = response.fees[i]
    result[fee.symbol] = {
      ...result[fee.symbol],
      fee: Number(fee.minorValue) / getMinorUnits(fee.symbol)
    }
  }
  for (let i = 0; i < response.minAmounts.length; i += 1) {
    const min = response.minAmounts[i]
    result[min.symbol] = {
      ...result[min.symbol],
      min: Number(min.minorValue) / getMinorUnits(min.symbol)
    }
  }
  return result
}

const fetchWithdrawalMinsAndFees = function* (action: Fetch) {
  const {
    payload: { paymentMethod }
  } = action
  const apiPm = paymentMethod === 'ALL' ? undefined : paymentMethod
  const data = yield call(getWithdrawalMinsAndFees, apiPm)
  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }
  const getMinorUnits = yield select(selectors.currencies.getMinorUnitsFactory)
  yield put(fetchSuccess(paymentMethod, mapServiceResponse(data.response, getMinorUnits)))
}

export default function* withdrawFeesAndMinSagas() {
  yield takeEvery(FETCH, fetchWithdrawalMinsAndFees)
}
